import React from 'react';

import Delete from 'Components/Partials/Modals/Delete';
import {IndexTable} from 'Components/Utilities';

import AdminLayout from 'Pages/Admin/AdminLayout';
import EndPoll from 'Pages/Admin/MainStage/Modals/EndPoll';

import PollsApi from 'Services/Api/Admin/MainStage/Polls';
import StartPoll from "Pages/Admin/MainStage/Modals/StartPoll";

export default class Polls extends React.Component {
    /**
     * @var columns
     * @type {array}
     */
    columns = [
        {
            label: 'Question',
            value: 'question',
            type: 'string',
            orderable: 'question'
        },
        {
            label: 'Display From',
            value: 'display_from',
            type: 'datetime',
            orderable: 'display_from'
        },
        {
            label: 'Display Until',
            value: 'display_until',
            type: 'datetime',
            orderable: 'display_until'
        },
    ];

    /**
     * @var state
     */
    state = {
        sessionId: this.props.match.params.session
    };

    /**
     * @method getRowActions
     * @param {object} item
     */
    getRowActions = (item) => {
        const {sessionId} = this.state;

        return [
            {
                type: "link",
                to: `/admin/main-stage/polls/${sessionId}/store/${item.id}`,
                text: "Edit"
            },
            {
                type: "modalTrigger",
                component: EndPoll,
                props: {
                    poll: item
                },
                text: 'End'
            },
            {
                type: "modalTrigger",
                component: StartPoll,
                props: {
                    poll: item
                },
                text: 'Start'
            },
            {
                type: "link",
                to: `/admin/main-stage/polls/${sessionId}/results/${item.id}`,
                text: "Results"
            },
            {
                type: "modalTrigger",
                component: Delete,
                props: {
                    itemName: 'session',
                    itemId: item.id,
                    onDeleteApi: (itemId, event, successStatus, config) => PollsApi.delete({
                        session: sessionId,
                        poll: itemId
                    }, event, successStatus, config)
                },
                text: 'Delete'
            }
        ];
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {sessionId} = this.state;

        return (
            <AdminLayout title="Main Stage - Polls">
                <IndexTable
                    columns={this.columns}
                    displaySearchBar={false}
                    storeLink={`/admin/main-stage/polls/${sessionId}/store`}
                    loadDataCallback={(data) => PollsApi.get({
                        session: sessionId
                    }, data)}
                    rowActions={this.getRowActions}
                    rowClickRedirect={(item) => `/admin/main-stage/polls/${sessionId}/store/${item.id}`}
                    actionsJustify="center"
                    eventApi={PollsApi}
                />
            </AdminLayout>
        );
    }
}
